import React, { Component } from 'react';
import { Grid, Button, Icon } from '@ali/aps-dev';
import { observer, inject } from 'mobx-react';
import './result.scss';

const Row = Grid.Row;
const Col = Grid.Col;
function toNumber(string) {
  let arr = string.split(',');
  return arr.join('');
}
@inject('resultListStore')
@observer
class ResultItem extends Component {
  constructor(props) {
    super(props);
    this.pageSize = this.props.resultListStore.pageSize;
  }
  componentDidMount() {
    this.props.resultListStore.fetchresultList();
  }

  render() {
    let resultList = this.props.resultListStore.resultList;
    const discountList = window['discountList'] || [];
    return (
      <div>
        {resultList.length
          ? resultList.map((item, index) => {
            let suffixArray = item.domainName.split('.');
            let suffix = suffixArray[suffixArray.length - 1];
            let discountItem = discountList.filter((listItem) => listItem.text == suffix);
            let discount = discountItem[0] ?
              (discountItem[0].value > 10 ? discountItem[0].value / 100 : discountItem[0].value / 10) : 1;
            return (
              < Row className="result-item" key={index} >
                <Col lg={14} ms={12} md={12} xs={12}>
                  <p className="domain-name">{item.domainName}</p>
                </Col>
                {
                  item.regDate
                    ? <Col lg={10} ms={12} md={12} xs={12}>
                      <p className="regested">
                        <Icon type="right1" />已注册
                      </p>
                    </Col>
                    : <Col lg={10} ms={12} md={12} xs={12}>
                      <Button
                        className="btn regester-btn"
                        type="normal"
                        onClick={this.props.resultListStore.addToCart
                          .bind(this.props.resultListStore, {
                            'domainString': item.domainName
                          })}>立即注册</Button>
                      <div className="price">
                        <p>
                          <span className="price-color">
                            ¥<span className="int-strong">
                              {item.price.split('.') ? Math.round(toNumber(item.price.split('.')[0]) * discount)
                                : item.price}
                              {/* {item.price.split('.') ? item.price.split('.')[0] : item.price} */}
                            </span>
                            {item.price.split('.') ? item.price.split('.')[1] : ''}
                          </span>／年
                          {discountItem[0] && <span className="discount-item">
                            {discountItem[0].target || '首年'}{discountItem[0].value}折
                          </span>}
                        </p>
                        <p>续费<span className="price-color">¥{item.bailPrice}</span>／年</p>
                      </div>
                    </Col>
                }
              </Row>);
          })
          : <Row classname="result-item"><Col><p className="domain-holder">没有查询到附合条件的域名</p></Col></Row>
        }
      </div>
    );
  }
}
export default ResultItem;


// WEBPACK FOOTER //
// ./src/components/Content/Result/ResultItem.js